import { Check } from "lucide-react";

const PRICES = [
  { label: "Erstgespräch", duration: "ca. 45 Minuten", price: "60,– €" },
  { label: "Therapiesitzung", duration: "60 Minuten", price: "100,– €" },
];

const ADVANTAGES = [
  "Keine langen Wartezeiten — gewöhnlich Termin innerhalb von 3 Wochen.",
  "Beratungs- und Therapiesequenzen werden individuell auf Sie abgestimmt.",
  "Dauer und Häufigkeit der Termine legen Sie selbst fest.",
  "Therapiesitzungen sind auch online via Zoom möglich.",
  "Im Einzelfall nehme ich auf Ihre soziale Situation Rücksicht.",
];

export default function Abrechnung() {
  return (
    <section
      id="abrechnung"
      data-testid="abrechnung-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <p className="eyebrow reveal">Honorar &amp; Abrechnung</p>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 reveal reveal-delay-1"
            style={{ color: "var(--ink)" }}
          >
            Transparent &amp;{" "}
            <em className="font-serif italic" style={{ color: "var(--sky-deep)" }}>persönlich</em>.
          </h2>
          <p
            className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed reveal reveal-delay-2"
            style={{ color: "var(--ink-soft)" }}
          >
            Sie erhalten eine monatliche Rechnung, die Sie innerhalb von 14 Tagen auf mein Konto
            überweisen. Im Einzelfall kann ich auf Ihre soziale Situation Rücksicht nehmen.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-10 lg:gap-12">
          {/* Price table */}
          <div className="lg:col-span-7">
            <div className="soft-card overflow-hidden reveal reveal-delay-2" data-testid="price-table">
              {PRICES.map((p, idx) => (
                <div
                  key={p.label}
                  data-testid={`price-row-${idx}`}
                  className={`flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-2 sm:gap-6 px-7 py-6 ${
                    idx > 0 ? "border-t" : ""
                  }`}
                  style={{ borderColor: "var(--line)" }}
                >
                  <div>
                    <h3 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>
                      {p.label}
                    </h3>
                    <p className="text-sm mt-1" style={{ color: "var(--ink-mute)" }}>
                      {p.duration}
                    </p>
                  </div>
                  <p
                    className="font-serif text-2xl sm:text-3xl whitespace-nowrap"
                    style={{ color: "var(--sky-deep)" }}
                  >
                    {p.price}
                  </p>
                </div>
              ))}
            </div>

            <div
              className="mt-6 soft-card p-7 reveal reveal-delay-3"
              data-testid="reimbursement-note"
            >
              <h3 className="font-serif text-xl" style={{ color: "var(--ink)" }}>
                Erstattung &amp; steuerlicher Hinweis
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed" style={{ color: "var(--ink-soft)" }}>
                Es ist möglich, dass Zusatzversicherungen für Heilpraktiker-Leistungen oder private
                Krankenversicherungen einen Teil der Kosten übernehmen. Bitte informieren Sie sich
                hierzu bei Ihrer Versicherung.
              </p>
              <p className="mt-3 text-[15px] leading-relaxed" style={{ color: "var(--ink-soft)" }}>
                Als außergewöhnliche Belastung können Sie die Leistung unter bestimmten
                Voraussetzungen steuerlich geltend machen.
              </p>
            </div>
          </div>

          {/* Advantages */}
          <div className="lg:col-span-5">
            <div
              className="rounded-3xl p-7 lg:p-8 h-full reveal reveal-delay-3"
              style={{ background: "var(--cream-deep)" }}
              data-testid="advantages-card"
            >
              <h3 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>
                Vorteile der privaten Abrechnung
              </h3>
              <ul className="mt-6 space-y-4">
                {ADVANTAGES.map((adv, idx) => (
                  <li
                    key={idx}
                    data-testid={`advantage-${idx}`}
                    className="flex items-start gap-3 text-[15px] leading-relaxed"
                    style={{ color: "var(--ink)" }}
                  >
                    <span
                      className="mt-0.5 shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-full"
                      style={{ background: "var(--sky)", color: "var(--ink)" }}
                    >
                      <Check size={15} strokeWidth={2.2} />
                    </span>
                    <span>{adv}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
